import {
  Box,
  Card,
  Flex,
  Form,
  Icon,
  Text,
  Button,
  Heading,
  CardBody,
  Textarea,
  IconButton,
  FormControl,
  FormErrorMessage,
  FormLabel,
  RadioGroup,
  Stack,
  Radio,
  Input,
  useToast,
  ModalBody,
  ModalFooter,
  ButtonGroup,
  ModalContent,
  ModalCloseButton,
  Modal,
  ModalOverlay,
  ModalHeader,
  Avatar
} from '@homebotapp/hb-react-component-catalog'
import {
  selectFullName,
  selectCustomerIsRealEstateAgent,
  selectCustomerIsLoanOfficer,
  selectIsSoloRea,
  selectIsSoloInsuranceAgent,
  selectScheduleACallUri,
  selectCustomerPhotoUri,
  selectCustomerFirstName,
  selectHasHomebotNetworkFeatureFlag
} from '../../../../store/selectors/customerProfile'
import { useEffect, useMemo, useState } from 'react'
import * as Sentry from '@sentry/browser'
import { useIntl, defineMessages } from 'react-intl'
import { useDispatch, useSelector } from 'react-redux'
import { useAppDispatch } from '../../../../store/hooks'
import useViewport from '../../../../hooks/useViewport'
import { ClientEventSource, Listing } from '../../../../api/gqlaxy/gql/generated/graphql'
import { flashNotification } from '../../../../actions/notification'
import { selectClientId, selectClientIsGuest } from '../../../../store/selectors/client'
import { toggleAuthModal } from '../../../../actions/homeSearchAuthModal'
import { HOME_SEARCH_LISTING_DETAILS } from '../../../../constants/tracking/trackingEventLocations/homeSearchTrackingEventLocation'
import { MessageTopicKey } from '../../../../api/gqlaxy/gql/generated/graphql'
import { useSendListingMessage } from '../../../../hooks/listings/useSendListingMessage'
import { useGetPreferredAgent } from '../../../../hooks/listings/useGetPreferredAgent'
import { useUpdatePreferredAgent } from '../../../../hooks/listings/useUpdatePreferredAgent'
import { hasCustomerToken } from '../../../../auth'
import { LeavingHomebotCtaButton } from '../../../shared/LeavingHomebotCta/LeavingHomebotCtaButton'
import { selectSponsorshipFullName, selectSponsorshipPhotoUri } from '../../../../store/selectors/sponsorship'
import { createTeamMembership } from '../../../../store/slices/homebotNetwork/clientTeamMemberships'

export const MSG = defineMessages({
  email: {
    id: 'AgentCard.email',
    defaultMessage: 'Email'
  },
  firstName: {
    id: 'FormField.label.firstName',
    defaultMessage: 'First Name'
  },
  lastName: {
    id: 'Form.placeholder.lastName',
    defaultMessage: 'Last Name'
  },
  whoDoYouWantToAsk: {
    id: 'ListingDetails.ListingAgentCard.whoDoYouWantToAsk',
    defaultMessage: 'Who do you want to ask?'
  },
  addCustomAgentNote: {
    id: 'ListingDetails.ListingAgentCard.addCustomAgentNote',
    defaultMessage: "Send your questions to agent you know. We'll save this info as an option for future questions."
  },
  addCustomAgent: {
    id: 'ListingDetails.ListingAgentCard.addCustomAgent',
    defaultMessage: 'Add a preferred agent'
  },
  ask: {
    id: 'ListingDetails.ListingAgentCard.ask',
    defaultMessage: 'Ask listing agent, {name}'
  },
  askRea: {
    id: 'ListingDetails.ListingAgentCard.askRea',
    defaultMessage: 'Ask your agent, {name}'
  },
  head: {
    id: 'ListingDetails.ListingAgentCard.head',
    defaultMessage: 'Have a question?'
  },
  fail: {
    id: 'ListingDetails.ListingAgentCard.fail',
    defaultMessage: 'Message failed to send'
  },
  submit: {
    id: 'ListingDetails.ListingAgentCard.submit',
    defaultMessage: 'Send message'
  },
  label: {
    id: 'ListingDetails.ListingAgentCard.label',
    defaultMessage: 'Your question'
  },
  required: {
    id: 'ListingDetails.ListingAgentCard.required',
    defaultMessage: 'Required'
  },
  agent: {
    id: 'ListingDetails.ListingAgentCard.listAgent',
    defaultMessage: 'Listing agent'
  },
  rea: {
    id: 'ListingDetails.ListingAgentCard.rea',
    defaultMessage: 'Real estate agent'
  },
  show: {
    id: 'ListingDetails.ListingAgentCard.show',
    defaultMessage: 'Show agent contact card'
  },
  hide: {
    id: 'ListingDetails.ListingAgentCard.hide',
    defaultMessage: 'Hide agent contact card'
  },
  sub: {
    id: 'ListingDetails.ListingAgentCard.subhead',
    defaultMessage: 'We connect you directly to the listing agent who knows the property best. No cold calls or spam!'
  },
  reaSub: {
    id: 'ListingDetails.ListingAgentCard.reaSubhead',
    defaultMessage: 'We connect you directly to your agent to answer your questions about this property'
  },
  footer: {
    id: 'ListingDetails.ListingAgentCard.footer',
    defaultMessage:
      "By clicking 'Send a Message' you authorize HB Real Estate Services, Inc. and Homebot, Inc. to share your contact information (name and email address) and any other information you include in your question with the listing agent identified above. You agree that the listing agent may may contact you about your inquiry."
  },
  sendMsgImpersonating: {
    id: 'ListingDetails.ListingAgentCard.sendMsgImpersonation',
    defaultMessage: 'Sending a message on behalf of your clients is not supported at this time.'
  },
  scheduleACallHeaderText: {
    id: 'ListingDetails.ListingAgentCard.scheduleACallHeaderText',
    defaultMessage: 'Schedule a call'
  },
  continueText: {
    id: 'ListingDetails.ListingAgentCard.continueText',
    defaultMessage: "Do you want to continue to {name}'s scheduling site in a new tab?"
  },
  orYouCan: {
    id: 'ListingDetails.ListingAgentCard.orYouCan',
    defaultMessage: 'Or you can'
  },
  messageSent: {
    id: 'ListingDetails.ListingAgentCard.messageSent',
    defaultMessage: 'Message sent!'
  },
  prequalSentSuccess: {
    id: 'ListingDetails.ListingAgentCard.prequalSentSuccess',
    defaultMessage: 'Pre-qualification request sent!'
  },
  customerFirstNameWillRespond: {
    id: 'ListingDetails.ListingAgentCard.customerFirstNameWillRespond',
    defaultMessage: '{customerFirstName} will be in touch soon to answer your question.'
  },
  inTheMeantime: {
    id: 'ListingDetails.ListingAgentCard.inTheMeantime',
    defaultMessage: 'In the meantime, would you like to get pre-qualified?'
  },
  inTheMeantimeSponsored: {
    id: 'ListingDetails.ListingAgentCard.inTheMeantimeSponsored',
    defaultMessage: 'Would you like to get pre-qualified by my trusted lending partner, {sponsorName} in the meantime?'
  },
  preQualifyDescription: {
    id: 'ListingDetails.ListingAgentCard.preQualifyDescription',
    defaultMessage:
      'Pre-qualifying gives you a clear budget with no obligation to proceed, and makes you stand out as a serious buyer.'
  },
  cancel: {
    id: 'ListingDetails.ListingAgentCard.cancel',
    defaultMessage: 'Cancel'
  },
  getPreQualified: {
    id: 'ListingDetails.ListingAgentCard.getPreQualified',
    defaultMessage: 'Get pre-qualified'
  }
})

export interface RealEstateAgentCardProps {
  listing?: Listing
  cardOnly?: boolean
}

export interface AgentOptions {
  type?: string
  email?: string | null
  name?: string | null
  company?: string | null
}

export interface CustomPreferredAgent {
  firstName?: string
  lastName?: string
  email?: string
}

export interface MessageFormValues extends CustomPreferredAgent {
  question: string
  preferredAgent?: string | null
}

export const RealEstateAgentCard = ({ listing, cardOnly = false }: RealEstateAgentCardProps) => {
  const intl = useIntl()
  const dispatch = useDispatch()
  const appDispatch = useAppDispatch()
  const customerPhoto = useSelector(selectCustomerPhotoUri)
  const isGuest = useSelector(selectClientIsGuest)
  const customerName = useSelector(selectFullName)
  const customerFirstName = useSelector(selectCustomerFirstName)
  const sponsorName = useSelector(selectSponsorshipFullName)
  const sponsorPhoto = useSelector(selectSponsorshipPhotoUri)
  const isSoloRea = useSelector(selectIsSoloRea)
  const isSoloInsuranceAgent = useSelector(selectIsSoloInsuranceAgent)
  const isCustomerREA = useSelector(selectCustomerIsRealEstateAgent)
  const isCustomerLo = useSelector(selectCustomerIsLoanOfficer)
  const clientId = useSelector(selectClientId) as string
  const { isLargeOrAbove } = useViewport()
  const [isHidden, setIsHidden] = useState(false)
  const scheduleACallUri = useSelector(selectScheduleACallUri)
  const [isShowingPrequalModal, setIsShowingPrequalModal] = useState(false)

  const topic = isCustomerREA
    ? MessageTopicKey.ListingsDirectMessage
    : MessageTopicKey.ListingsDirectMessageToListingAgent

  const { data: preferredAgentData } = useGetPreferredAgent(
    {
      input: {
        clientId
      }
    },
    {
      enabled: isCustomerLo
    }
  )

  const toast = useToast()
  const isImpersonating = hasCustomerToken()

  const { mutateAsync: updatePreferredAgent } = useUpdatePreferredAgent()

  const hasPreferredAgent = !!preferredAgentData?.preferredAgent?.agentEmail

  const [selectedAgentEmail, setSelectedAgentEmail] = useState<string | undefined | null>(listing?.agent?.email)
  const [customPreferredAgent, setCustomPreferredAgent] = useState<CustomPreferredAgent>({})
  const [emailIsValid, setEmailIsValid] = useState(true)
  const isCustomerOnHomebotNetwork = useSelector(selectHasHomebotNetworkFeatureFlag)

  useEffect(() => {
    if (hasPreferredAgent) setSelectedAgentEmail(preferredAgentData?.preferredAgent.agentEmail)
  }, [hasPreferredAgent, preferredAgentData?.preferredAgent])

  useEffect(() => {
    if (isLargeOrAbove) {
      setIsHidden(false)
    } else {
      setIsHidden(true)
    }
  }, [isLargeOrAbove])

  const { mutateAsync: sendListingMessage, isLoading: isSendingListingMessage } = useSendListingMessage()

  const scheduleACallRenderModalBody = () => {
    return (
      <Text>
        {intl.formatMessage(MSG.continueText, {
          name: customerName
        })}
      </Text>
    )
  }

  const updateAgent = async () => {
    let updated = true

    try {
      if (selectedAgentEmail === 'custom') {
        if (customPreferredAgent?.email && customPreferredAgent?.firstName) {
          if (isCustomerOnHomebotNetwork) {
            await appDispatch(
              createTeamMembership({
                clientId,
                preferredAgentFirstName: customPreferredAgent?.firstName,
                preferredAgentLastName: customPreferredAgent?.lastName,
                preferredAgentEmail: customPreferredAgent?.email,
                isVerified: true
              })
            ).unwrap()
          } else {
            const response = await updatePreferredAgent({
              input: {
                agentEmail: customPreferredAgent?.email,
                agentFirstName: customPreferredAgent?.firstName,
                agentLastName: customPreferredAgent?.lastName
              }
            })
            setCustomPreferredAgent({})
            updated = !!response?.updatePreferredAgent?.agentEmail
          }
        }
      }
    } catch (error) {
      updated = false
    }

    return updated
  }

  const handleSubmit = async (data: MessageFormValues) => {
    if (isGuest) {
      return dispatch(toggleAuthModal(true))
    }
    if (isImpersonating) {
      return toast({
        description: intl.formatMessage(MSG.sendMsgImpersonating),
        status: 'warning',
        position: 'top'
      })
    }
    const agentUpdated = await updateAgent()

    if (!agentUpdated || !listing?.id) {
      return dispatch(flashNotification({ message: intl.formatMessage(MSG.fail), messageType: 'error' }))
    }

    try {
      await sendListingMessage({
        input: {
          message: data.question,
          listingId: listing.id,
          topicKey: topic,
          sendToPreferredAgent: selectedAgentEmail !== listing.agent?.email
        }
      })
      if (isSoloRea || isSoloInsuranceAgent) {
        toast({
          title: intl.formatMessage(MSG.messageSent),
          status: 'success'
        })
      } else {
        return setIsShowingPrequalModal(true)
      }
    } catch (err) {
      Sentry.captureMessage('DM failed to send', {
        extra: {
          // @ts-ignore
          error: err.message || '',
          // @ts-ignore
          requestData: err.config?.data || {},
          // @ts-ignore
          requestErrors: Object.values(err?.response?.data?.errors || {})
        }
      })
      return dispatch(flashNotification({ message: intl.formatMessage(MSG.fail), messageType: 'error' }))
    }
  }

  const handleSubmitPrequalRequest = async () => {
    await sendListingMessage({
      input: {
        message: 'I want to get pre-qualified for this home.',
        topicKey: MessageTopicKey.ListingsPrequalRequest,
        listingId: listing?.id
      }
    })
    toast({
      title: intl.formatMessage(MSG.prequalSentSuccess),
      status: 'success'
    })
    setIsShowingPrequalModal(false)
  }

  const agents = useMemo(() => {
    const agentListOptions: AgentOptions[] = [
      {
        type: 'LISTING AGENT',
        email: listing?.agent?.email,
        name: listing?.agent?.name || listing?.agent?.email,
        company: listing?.brokerage?.name
      }
    ]

    if (preferredAgentData?.preferredAgent?.agentEmail) {
      agentListOptions.push({
        type: 'YOUR PREFERRED AGENT',
        email: preferredAgentData?.preferredAgent?.agentEmail,
        name: `${preferredAgentData?.preferredAgent?.agentFirstName} ${preferredAgentData?.preferredAgent?.agentLastName}`,
        company: undefined
      })
    }
    if (!hasPreferredAgent) {
      agentListOptions.push({
        type: intl.formatMessage(MSG.addCustomAgent).toUpperCase(),
        email: 'custom',
        name: '',
        company: intl.formatMessage(MSG.addCustomAgentNote)
      })
    }

    return agentListOptions
  }, [listing, preferredAgentData?.preferredAgent]) satisfies AgentOptions[]

  const sendButtonEnabled = useMemo(() => {
    let enabled = false
    if (!emailIsValid) return false
    if (selectedAgentEmail === 'custom') {
      enabled = !!customPreferredAgent.email && !!customPreferredAgent.firstName
    } else {
      enabled = !!selectedAgentEmail
    }
    return enabled
  }, [selectedAgentEmail, customPreferredAgent])

  const validateEmail = () => {
    if (customPreferredAgent.email) {
      const email = customPreferredAgent.email
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      if (!emailRegex.test(email)) {
        setEmailIsValid(false)
        dispatch(flashNotification({ message: 'Invalid email', messageType: 'error' }))
        return
      }
      setEmailIsValid(true)
    }
  }

  if (!isCustomerREA && !listing?.agent?.email) return null

  return (
    <>
      {/* @ts-ignore */}
      <Card size={'lg'} backgroundColor='var(--hb-colors-primary-50) !important'>
        <CardBody p={4}>
          <Flex justify='space-between' align={isHidden ? 'center' : 'flex-start'}>
            <Flex gap={2} align='center'>
              <Box>
                <Heading
                  as='h3'
                  textAlign='left'
                  mb={isHidden ? 0 : 1}
                  size={isHidden ? '3xs' : 'sm'}
                  variant={isHidden ? 'eyebrow' : undefined}
                  fontWeight={isHidden ? 'semibold' : 'bold'}
                  color={isHidden ? 'primary.700' : 'neutral.900'}
                >
                  {intl.formatMessage(MSG.head)}
                </Heading>
                {isHidden && (
                  <Heading as='h4' mb={0} size='3xs'>
                    {isCustomerREA
                      ? intl.formatMessage(MSG.askRea, { name: customerName })
                      : intl.formatMessage(MSG.ask, { name: listing?.agent?.name })}
                  </Heading>
                )}
              </Box>
            </Flex>
            <IconButton
              size='xs'
              display={cardOnly ? 'none' : ['flex', null, null, 'none']}
              onClick={() => setIsHidden(!isHidden)}
              icon={<Icon name={isHidden ? 'angle-up' : 'angle-down'} />}
              aria-label={intl.formatMessage(isHidden ? MSG.show : MSG.hide)}
              tracking={{
                guid: 'iyatREAj3S72vDVQtTuzc4',
                ui_context: HOME_SEARCH_LISTING_DETAILS,
                descriptor: isHidden ? MSG.show.defaultMessage : MSG.hide.defaultMessage
              }}
            />
          </Flex>
          {(!isHidden || cardOnly) && (
            <>
              <Text size='xs' id='agent-question-desc'>
                {intl.formatMessage(isCustomerREA ? MSG.reaSub : MSG.sub)}
              </Text>

              <Form
                onSubmit={handleSubmit}
                values={{
                  question: '',
                  preferredAgent: selectedAgentEmail
                }}
              >
                {({ formState: { errors, isValid } }) => (
                  <>
                    <FormControl isInvalid={!!errors?.question} mb={4}>
                      <FormLabel>{intl.formatMessage(MSG.label)}</FormLabel>
                      <Textarea
                        size='xs'
                        name='question'
                        borderRadius={8}
                        color='neutral.900'
                        aria-describedby='agent-question-desc'
                        rules={{ required: intl.formatMessage(MSG.required) }}
                      />
                      <FormErrorMessage>{errors?.question?.message?.toString()}</FormErrorMessage>

                      {isCustomerLo && (
                        <Box mt={4}>
                          <Text mb={-4} size='sm' fontWeight={600}>
                            {intl.formatMessage(MSG.whoDoYouWantToAsk)}
                          </Text>
                          <RadioGroup
                            name='preferredAgent'
                            onChange={(event: React.FormEvent<HTMLDivElement>) => {
                              const target = event.target as HTMLInputElement
                              setSelectedAgentEmail(target.value)
                            }}
                          >
                            <Stack direction='column'>
                              {agents.map((agent, i) => (
                                <Box mt={i > 0 ? -8 : 0} key={i}>
                                  <Radio value={agent?.email as string}>
                                    <Box pt={8}>
                                      <Text m={0} size='3xs' color='primary'>
                                        {agent?.type}
                                      </Text>
                                      <Text m={0} size='xs'>
                                        {agent?.name}
                                      </Text>
                                      <Text m={0} size='3xs' color='neutral-700'>
                                        {agent?.company ?? '-'}
                                      </Text>
                                    </Box>
                                  </Radio>
                                </Box>
                              ))}
                            </Stack>
                          </RadioGroup>

                          {!hasPreferredAgent && (
                            <Box>
                              <Box mt={4}>
                                {selectedAgentEmail === 'custom' && (
                                  <Flex flexDirection='column' gap={3}>
                                    <Flex gap={2}>
                                      <Box>
                                        <Flex gap={1}>
                                          <Text m={0} size='xs'>
                                            {intl.formatMessage(MSG.firstName)}
                                          </Text>
                                          <Text m={0} size='xs' color='danger'>
                                            *
                                          </Text>
                                        </Flex>
                                        <Input
                                          value={customPreferredAgent.firstName}
                                          onChange={e => {
                                            setCustomPreferredAgent({
                                              ...customPreferredAgent,
                                              firstName: e.target.value
                                            })
                                          }}
                                          size='sm'
                                          name='firstName'
                                        />
                                      </Box>
                                      <Box>
                                        <Flex gap={1}>
                                          <Text m={0} size='xs'>
                                            {intl.formatMessage(MSG.lastName)}
                                          </Text>
                                          <Text m={0} size='xs' color='danger'>
                                            *
                                          </Text>
                                        </Flex>
                                        <Input
                                          value={customPreferredAgent.lastName}
                                          onChange={e => {
                                            setCustomPreferredAgent({
                                              ...customPreferredAgent,
                                              lastName: e.target.value
                                            })
                                          }}
                                          size='sm'
                                          name='lastName'
                                        />
                                      </Box>
                                    </Flex>
                                    <Box>
                                      <Flex gap={1}>
                                        <Text m={0} size='xs'>
                                          {intl.formatMessage(MSG.email)}
                                        </Text>
                                        <Text m={0} size='xs' color='danger'>
                                          *
                                        </Text>
                                      </Flex>
                                      <Input
                                        isInvalid={!emailIsValid}
                                        type='email'
                                        value={customPreferredAgent.email}
                                        onBlur={validateEmail}
                                        onChange={e => {
                                          setCustomPreferredAgent({
                                            ...customPreferredAgent,
                                            email: e.target.value
                                          })
                                        }}
                                        size='sm'
                                        name='email'
                                      />
                                    </Box>
                                  </Flex>
                                )}
                              </Box>
                            </Box>
                          )}
                        </Box>
                      )}
                    </FormControl>

                    <Button
                      w='100%'
                      type='submit'
                      isDisabled={!sendButtonEnabled || !isValid}
                      isLoading={isSendingListingMessage}
                      colorScheme='primary'
                      leftIcon={<Icon name='message' />}
                      tracking={{
                        guid: 'nG8M7arfPw3NsuN3dfLGMq',
                        ui_context: HOME_SEARCH_LISTING_DETAILS,
                        descriptor: MSG.submit.defaultMessage
                      }}
                    >
                      {intl.formatMessage(MSG.submit)}
                    </Button>
                  </>
                )}
              </Form>
              {!isCustomerREA && (
                <Text mb={0} mt={4} size='3xs'>
                  {intl.formatMessage(MSG.footer)}
                </Text>
              )}
            </>
          )}
          {isSoloRea && isSoloInsuranceAgent && (
            <Flex justifyContent='left' flex={'0 0 auto'} mt={2}>
              <Flex gap={1} alignItems='baseline' justifyContent='left'>
                <Text as='span'>{intl.formatMessage(MSG.orYouCan)}</Text>
                <LeavingHomebotCtaButton
                  scheduleACall
                  ctaButtonSize='sm'
                  ctaButtonColorScheme='primary'
                  hideIllustration
                  eventSource={ClientEventSource.ListingDetailed}
                  headerText={intl.formatMessage(MSG.scheduleACallHeaderText)}
                  ctaButtonVariant={'link'}
                  ctaLinkUrl={scheduleACallUri}
                  renderModalBody={scheduleACallRenderModalBody}
                  tracking={{
                    guid: 'gm5AA5XCfwHAcRKMKzdxQb',
                    ui_context: 'Listing Details - DM Card',
                    descriptor: 'Schedule a call button clicked'
                  }}
                >
                  {intl.formatMessage(MSG.scheduleACallHeaderText).toLowerCase()}
                </LeavingHomebotCtaButton>
              </Flex>
            </Flex>
          )}
        </CardBody>
      </Card>
      <Modal isOpen={isShowingPrequalModal} onClose={() => setIsShowingPrequalModal(false)} size='lg'>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            <Heading as='h2' textAlign='left' display='flex' alignItems='center' mb={2}>
              ✅{' '}
              <Text ml={2} as='span' mb={0}>
                {intl.formatMessage(MSG.messageSent)}
              </Text>
            </Heading>
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Box>
              <Text color='neutral.800'>
                {intl.formatMessage(MSG.customerFirstNameWillRespond, { customerFirstName: customerFirstName })}
              </Text>
              <Card>
                <CardBody bgColor='card-bg-layer-3'>
                  <Flex mb={3}>
                    <Avatar src={customerPhoto} />
                    {sponsorPhoto && <Avatar src={sponsorPhoto} ml={-5} />}
                    <Text fontWeight='bold' color='neutral.900' ml={3} mb={0}>
                      {sponsorName
                        ? intl.formatMessage(MSG.inTheMeantimeSponsored, { sponsorName: sponsorName })
                        : intl.formatMessage(MSG.inTheMeantime)}
                    </Text>
                  </Flex>
                  <Text size='xs' color='neutral.900'>
                    {intl.formatMessage(MSG.preQualifyDescription)}
                  </Text>
                </CardBody>
              </Card>
            </Box>
          </ModalBody>
          <ModalFooter>
            <ButtonGroup spacing={3}>
              <Button
                variant='ghost'
                onClick={() => setIsShowingPrequalModal(false)}
                tracking={{
                  guid: 'nzQMzEsfYCozhc7VyMMsNU',
                  ui_context: HOME_SEARCH_LISTING_DETAILS,
                  descriptor: 'Cancel from prequal modal after sending listing agent a message'
                }}
              >
                {intl.formatMessage(MSG.cancel)}
              </Button>
              <Button
                colorScheme='primary'
                onClick={handleSubmitPrequalRequest}
                tracking={{
                  guid: '6CqybULCtMQPvUYHmJsBDy',
                  ui_context: HOME_SEARCH_LISTING_DETAILS,
                  descriptor:
                    'Get pre-qualified button clicked from prequal modal after sending listing agent a message'
                }}
              >
                {intl.formatMessage(MSG.getPreQualified)}
              </Button>
            </ButtonGroup>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}
